import { createPaginatedApiQuery } from "hooks/createPaginatedQuery";
import { shippingApi } from "./calls";

const useShippingShipments = createPaginatedApiQuery(shippingApi.getShippingShipments);

export const shippingActions = {
  useShippingShipments,
};
